import { AppConfig, CapabilityApplications } from '@hcs/types';

import { APP_CONFIG_AGILE_OPS_COMMAND } from './AppConfigAgileOpsCommand.config';
import { APP_CONFIG_CANARY_ADMIN } from './AppConfigCanaryAdmin.config';
import { APP_CONFIG_CERBERUS_EXPLORER } from './AppConfigCerberusExplorer.config';
import { APP_CONFIG_CLIENT_ADMIN } from './AppConfigClientAdmin.config';
import { APP_CONFIG_ENG_TOOLS } from './AppConfigEngTools.config';
import { APP_CONFIG_BULK_DATA } from './AppConfigInternalBulkData.config';
import { APP_CONFIG_PLATFORM_ADMIN } from './AppConfigPlatformAdmin.config';

/** generated by generate-export-buckets */
export * from './AppConfigAgileOpsCommand.config';
export * from './AppConfigCanaryAdmin.config';
export * from './AppConfigCerberusExplorer.config';
export * from './AppConfigClientAdmin.config';
export * from './AppConfigEngTools.config';
export * from './AppConfigInternalBulkData.config';
export * from './AppConfigPlatformAdmin.config';

export const INTERNAL_APP_CONFIGS = [
  APP_CONFIG_AGILE_OPS_COMMAND,
  APP_CONFIG_CANARY_ADMIN,
  APP_CONFIG_CERBERUS_EXPLORER,
  APP_CONFIG_CLIENT_ADMIN,
  APP_CONFIG_ENG_TOOLS,
  APP_CONFIG_BULK_DATA,
  APP_CONFIG_PLATFORM_ADMIN,
];

export const INTERNAL_APP_CONFIGS_BY_KEY = INTERNAL_APP_CONFIGS.reduce<
  Partial<Record<CapabilityApplications, AppConfig>>
>((data, appConfig) => {
  data[appConfig.applicationKey] = appConfig;
  return data;
}, {});
